import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';

import * as api from '../../api/uploadImage';

/**
 * @param filename
 *
 */
export function* getImage(params) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.getImage, params);
    return response.data;
  } catch (error) {
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* getLoadingImage() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    const response = yield call(api.getLoadingImage);
    return response.data;
  } catch (error) {
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}
